import { COLORS } from "./colors";

export interface MoodOption {
  /** Matches a color id in COLORS, so the mood always renders the exact same
   *  hex/name used everywhere else on the site and can link to /learn/:id. */
  id: string;
  label: string;
  hex: string;
  colorName: string;
}

// A curated span of 16 colors from the existing 175-color library, picked to
// cover a wide emotional range (energized -> heavy) while staying anchored to
// colors that already have full psychology write-ups on /learn/:id.
const MOOD_COLOR_IDS: { id: string; label: string }[] = [
  { id: "crimson", label: "Fired Up" },
  { id: "coral", label: "Playful" },
  { id: "tangerine", label: "Energized" },
  { id: "gold", label: "Optimistic" },
  { id: "yellow", label: "Joyful" },
  { id: "green", label: "Balanced" },
  { id: "sage", label: "Peaceful" },
  { id: "mint", label: "Refreshed" },
  { id: "sky-blue", label: "Calm" },
  { id: "teal", label: "Focused" },
  { id: "navy", label: "Serious" },
  { id: "violet", label: "Inspired" },
  { id: "lavender", label: "Dreamy" },
  { id: "plum", label: "Reflective" },
  { id: "gray", label: "Numb" },
  { id: "charcoal", label: "Heavy" },
];

export const MOOD_PALETTE: MoodOption[] = MOOD_COLOR_IDS.map(({ id, label }) => {
  const color = COLORS[id];
  if (!color) {
    throw new Error(`Mood palette references unknown color id "${id}"`);
  }
  return { id, label, hex: color.hex, colorName: color.name };
});

export function getMoodOption(id: string): MoodOption | undefined {
  return MOOD_PALETTE.find((m) => m.id === id);
}
